export default __webpack_public_path__ + "static/abmg-building-with-logo-white-683bf02644ee54bd1bf746e5dbb840d4.jpg";